import { useContext } from 'react';
import { createNamedContext } from '@trinity/chat-components';

type TagsToSummarizeContextValue = [number[], React.Dispatch<React.SetStateAction<number[]>>];

export const TagToSummarizeContext = createNamedContext<TagsToSummarizeContextValue>(null, 'TagToSummarizeContext');
export const useTagsToSummarize = () => useContext(TagToSummarizeContext);